"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Calendar = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var nucalm_1 = require("../../model/nucalm");
var service_1 = require("../../../library/base/service");
var Calendar = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Calendar, _super);
    function Calendar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '日历信息';
        _this.code = '101201';
        _this.desc = '日历信息';
        _this.requestParams = new nucalm_1.NucalmRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return Calendar;
}(service_1.BaseService));
exports.Calendar = Calendar;
//# sourceMappingURL=calendar.js.map